import { render } from "./ImageChoice.vue?vue&type=template&id=6dccbb6e"
import script from "./ImageChoice.vue?vue&type=script&lang=js"
export * from "./ImageChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__